import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import config from './config'
import serverConfig from './config/server'

const getApolloHygraphClient = (clientSide?: boolean): ApolloClient => {
  const httpLink = new HttpLink({ uri: config.hygraph.url })

  const authLink = setContext((_, { headers }) => {
    const token = serverConfig.hygraph.apiKey

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    }
  })

  const hygraphClient = new ApolloClient({
    ssrMode: !clientSide,
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
  })

  return hygraphClient
}

export default getApolloHygraphClient
